var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgSuitcase = function SvgSuitcase(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M387.098 156.25a45.651 45.651 0 0 0-45.598-45.598h-20.902V64.098h1.902a17.098 17.098 0 0 0 0-34.196h-133a17.098 17.098 0 1 0 0 34.196h1.902v46.554H170.5a45.651 45.651 0 0 0-45.598 45.598v209a45.312 45.312 0 0 0 16.378 34.709 49.855 49.855 0 0 0-11.628 31.791 50.348 50.348 0 0 0 100.696 0 49.867 49.867 0 0 0-4.68-20.902h60.665a49.867 49.867 0 0 0-4.68 20.902 50.348 50.348 0 0 0 100.696 0 49.855 49.855 0 0 0-11.629-31.791 45.312 45.312 0 0 0 16.378-34.709Zm-161.5-92.152h60.804v46.554h-60.804ZM229.4 336.75a17.098 17.098 0 0 1-34.196 0v-152a17.098 17.098 0 0 1 34.196 0Zm87.398 0a17.098 17.098 0 0 1-34.196 0v-152a17.098 17.098 0 0 1 34.196 0Z"
  })));
};

export default SvgSuitcase;